import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { InfoService } from '../../services/info.service';
import { MomentModule } from 'ngx-moment';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports: [DatePipe, MomentModule]
})
export class FooterComponent {
  readonly info = toSignal(inject(InfoService).getInfo$());
  readonly year = new Date().getFullYear();
}
